import {requestbody} from './request.js'
import {requestBlob} from './request.js'

//结果展示分页查询
export async function jxtjb_query (params = {
}) {
    return await requestbody('/iinvDataDisposeCenter/adjust/query', 'post', params)
}

//结果展示分页查询
export async function jxtjb_detail_query (params = {
}) {
    return await requestbody('/iinvDataDisposeCenter/adjust/query/detail', 'post', params)
}

//修改remark
export async function jxtjb_detail_update_remark (params = {
}) {
    return await requestbody('/iinvDataDisposeCenter/adjust/updateReamrk', 'post', params)
}

//结果展示分页查询
export async function jxtjb_get_fpimage (params = {
}) {
    return await requestBlob('iinvDataDisposeCenter/adjust/getFapinfoImage', 'get', params)
}